import { Loader } from '@googlemaps/js-api-loader';
const map = document.getElementById( 'map' );

if ( map ) {

	const loader = new Loader( {
		apiKey: 'AIzaSyClu3M7UIIxcIJZEjTwJ-x2yBYzXj8rhm0',
		version: 'weekly',
		libraries: [],
	} );

	loader
		.load()
		.then( ( google ) => {
			const myLatLng = { lat: 57.675650, lng: -2.023300 };

			const googleMap = new google.maps.Map( map, {
				zoom: 16,
				center: myLatLng,
			} );

			const marker = new google.maps.Marker({
				position: myLatLng,
				map: map
			});

			const contentString =
				'<div id="content">' +
				'<p><strong>Colaren Homes</strong><br>' +
				'Fair Isle Drive,<br>' +
				'Fraserburgh<br>' +
				'AB43 7FY</p>' +
				'</div>';

			const infowindow = new google.maps.InfoWindow({
				content: contentString,
			});

			marker.addListener( 'click', () => {
				infowindow.open({
					anchor: marker,
					map,
					shouldFocus: false,
				});
			});

			marker.setMap(googleMap);
		} )
		.catch( ( e ) => {
			map.innerHTML = e.message;
		} );
}
